module.exports = __webpack_public_path__ + "media/images/self_destructing-9a4549edf2afef84ef81a79cb13786f8.png";